import crmService from '../../services/crmService'

export default {
  state: {
    orders: [],
    statuses: [],
    pagination: {
      perPage: 50,
      currentPage: 1,
      total: null,
      statusId: 'all',
      perPageOptions: [5, 10, 25, 50],
    },
  },
  mutations: {
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination
    },
    SET_STATUS_ID(state, statusId) {
      state.pagination.statusId = statusId
    },
    SET_ORDERS(state, orders) {
      state.orders = Array.from(orders)
    },
    SET_STATUSES(state, statuses) {
      state.statuses = statuses
    },
    SET_FILTER(state, filter) {
      state.filter = filter
    },
    ANONYMIZE(state, id) {
      const indexArr = []
      state.orders.forEach((order, index) => {
        if (order.customer_id === id) {
          indexArr.push(index)
        }
      })
      indexArr.forEach(index => {
        state.orders[index].name = '*****'
        state.orders[index].surname = '*****'
        state.orders[index].phone = '*****'
        state.orders[index].email = '*****'
      })
    },
  },
  actions: {
    async fetchOrders({ commit }, payload) {
      const { data } = await crmService.fetchOrders(payload)
      commit('SET_ORDERS', data.offerList)
      commit('SET_PAGINATION', {
        perPage: data.pageSize,
        currentPage: data.currentPage,
        total: data.totalCount,
        pageCount: data.totalPages,
        perPageOptions: [5, 10, 25, 50],
      })
    },
    async fetchStatuses({ commit }, token) {
      const { data } = await crmService.fetchStatuses(token)
      commit('SET_STATUSES', data)
    },
    changeStatus(ctx, payload) {
      return crmService.changeStatus(payload.id, payload.status)
    },
    reassignSeller(ctx, payload) {
      return crmService.reassignSeller(payload)
    },
    anonymize({ commit }, id) {
      crmService.anonymize(id).then(() => commit('ANONYMIZE', id))
    },
    addComment(ctx, payload) {
      crmService.addComment(payload.id, payload.comment)
    },
    getRaport(ctx, payload) {
      return crmService.getRaport(payload.dateRange)
    },
    getRaportPdf(ctx, payload) {
      return crmService.getRaportPdf(payload.id)
    },
  },
  getters: {
    allOrders: state => state.orders,
    statuses: state => state.statuses,
    pagination: state => state.pagination,
  },
}
